import { useCallback, useEffect, useState } from "react";
import { fetchActivityFeed } from "@/api/homeReportingApi";

export function useHomeActivity({ startDate, endDate, enabled = true }, { limit = 10 } = {}) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(/** @type {Error | null} */ (null));
  const [tick, setTick] = useState(0);

  const refresh = useCallback(() => setTick((t) => t + 1), []);

  useEffect(() => {
    if (!enabled) {
      setLoading(false);
      setError(null);
      setData(null);
      return undefined;
    }
    const ac = new AbortController();
    setLoading(true);
    setError(null);
    fetchActivityFeed({ startDate, endDate }, { limit }, { signal: ac.signal })
      .then((res) => {
        if (ac.signal.aborted) return;
        setData(res?.items ?? []);
      })
      .catch((e) => {
        if (ac.signal.aborted) return;
        setError(e instanceof Error ? e : new Error(String(e)));
        setData(null);
      })
      .finally(() => {
        if (!ac.signal.aborted) setLoading(false);
      });
    return () => ac.abort();
  }, [startDate, endDate, limit, tick, enabled]);

  return { data, loading, error, refresh };
}
